<template>
  <section class="block portal__component account">
    <base-notify :message="notification" :status="notifyStatus" />
    <div class="portal__content account__list">
      <component
        :is="accountComponent"
        @edit-account="editAccount"
        @cancel-edit-account="cancelEditAccount"
        @end-edit-account="endEditAccount"
        @edit-account-error="notify('error', 'Something went wrong, please retry')"
      ></component>
      <component
        :is="inlogComponent"
        @edit-login="editLogin"
        @cancel-edit-login="cancelEditLogin"
        @end-edit-login="endEditLogin"
        @edit-login-error="notify('error', 'Something went wrong, please retry')"
      ></component>
    </div>
  </section>
</template>

<script>
import AccountData from '@/components/account/AccountData.vue'
import InlogData from '@/components/account/InlogData.vue'
import AccountDataEdit from '@/components/account/AccountDataEdit.vue'
import InlogDataEdit from '@/components/account/InlogDataEdit.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'AccountView',
  components: {
    AccountData,
    InlogData,
    AccountDataEdit,
    InlogDataEdit
  },
  data () {
    return {
      accountComponent: AccountData,
      inlogComponent: InlogData,
      notification: '',
      notifyStatus: ''
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString'
    })
  },
  methods: {
    notify (status, message) {
      this.notification = message
      this.notifyStatus = status
    },
    editAccount () {
      this.accountComponent = AccountDataEdit
      this.notifyStatus = ''
    },
    cancelEditAccount () {
      this.accountComponent = AccountData
    },
    endEditAccount () {
      this.accountComponent = AccountData
      this.notify('ok', this.getUiString(['my_account', 'contact_info', 'changes_saved_confirmation']))
    },
    editLogin () {
      this.inlogComponent = InlogDataEdit
      this.notifyStatus = ''
    },
    cancelEditLogin () {
      this.inlogComponent = InlogData
    },
    endEditLogin () {
      this.inlogComponent = InlogData
      this.notify('ok', this.getUiString(['my_account', 'contact_info', 'password_changed_text']))
    }
  }
}
</script>
